import type { IAvatarProps } from '@sixui/ui';
import { Avatar, getTextContrastColor } from '@sixui/ui';
import { avatarTokens } from '@sixui/ui/components/Avatar/Avatar.stylex';
import stylex from '@stylexjs/stylex';

import type { IApiGetAppResponseBody } from '~/lib/api/modules/Apps';

export type IAppIconProps = IAvatarProps & {
  app?: IApiGetAppResponseBody;
};

const styles = stylex.create({
  avatar: (backgroundColor: string, foregroundColor: string) => ({
    [avatarTokens.containerColor]: backgroundColor,
    [avatarTokens.labelTextColor]: foregroundColor,
  }),
});

export const AppIcon: React.FC<IAppIconProps> = (props) => {
  const { app, ...other } = props;
  const preferredBackgroundColor =
    app?.settings?.press?.env?.appThemeColorPrimary;
  const foregroundColor = preferredBackgroundColor
    ? getTextContrastColor(preferredBackgroundColor)
    : undefined;

  return (
    <Avatar
      sx={
        preferredBackgroundColor && foregroundColor
          ? styles.avatar(preferredBackgroundColor, foregroundColor)
          : undefined
      }
      fallbackToRandomColor={!preferredBackgroundColor || !foregroundColor}
      randomColorSourceString={app?._id}
      variant="squared"
      src={app?.icon?.thumbUrl}
      {...other}
    >
      {app?.name[0]}
    </Avatar>
  );
};
